import {HStack, Text, Image} from '@chakra-ui/react'

const BlogAuthor = ({name, image, date}) => (
	<HStack marginTop="2" pb="10px" spacing="2" display="flex" alignItems="center">
		{image && <Image borderRadius="full" boxSize="40px" src={image}/>}
		<Text fontWeight="medium">{name}</Text>
		<Text>—</Text>
		<Text>{`${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`}</Text>
	</HStack>
)

export default BlogAuthor